import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from "@azure/msal-react";
import { loginRequest } from "../../authConfig";
import Button from "@material-ui/core/Button";
import { useRecoilState } from "recoil";
import {
  sideDrawerState,
  priceCheckDrawerState,
  comparePlayerStatDrawerState,
} from "../../Atoms/uiAtom";

import Header from "./Header/Header";
import Menu from "./Menu/Menu";
import SignIn from "../SignIn";
import PriceCheck from "./PriceCheck/PriceCheck";
import ComparePlayerStats from "./ComparePlayerStats/ComparePlayerStats";

const Layout = ({ children, title, routes }) => {
  const classes = useStyles();
  const [sideDrawer, setSideDrawer] = useRecoilState(sideDrawerState);
  const [priceCheckDrawer, setPriceCheckDrawer] = useRecoilState(
    priceCheckDrawerState,
  );
  const [comparePlayerStatDrawer, setComparePlayerStatDrawer] = useRecoilState(
    comparePlayerStatDrawerState,
  );

  const handleDrawer = () => {
    setSideDrawer(sideDrawer === "open" ? "closed" : "open");
  };

  const handleCloseComparePlayerStatDrawer = () => {
    setComparePlayerStatDrawer(false);
  };

  const SignInButton = () => {
    const { instance } = useMsal();
    return (
      <Button
        variant="contained"
        onClick={() =>
          instance.loginRedirect(loginRequest).catch(console.error)
        }
      >
        Sign in with Microsoft
      </Button>
    );
  };

  return (
    <>
      <AuthenticatedTemplate>
        <div className={classes.root}>
          <Header
            drawerOpen={sideDrawer === "open"}
            handleDrawer={handleDrawer}
            pageTitle={title}
            routes={routes}
          />
          <Menu drawerOpen={sideDrawer === "open"} />
          <main
            className={`${classes.content} ${
              sideDrawer === "open" && classes.contentShift
            }`}
          >
            <div className={classes.drawerHeader} />
            {children}
          </main>
        </div>
        {priceCheckDrawer === "open" && (
          <PriceCheck
            drawerOpen={priceCheckDrawer === "open"}
            setDrawerOpen={setPriceCheckDrawer}
          />
        )}
        {comparePlayerStatDrawer && (
          <ComparePlayerStats
            open={comparePlayerStatDrawer}
            onClose={handleCloseComparePlayerStatDrawer}
          />
        )}
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <SignIn>
          {!process.env.REACT_APP_MSAL_CLIENT_ID && (
            <p style={{ color: "red" }}>Azure AD Client Id not set</p>
          )}
          <SignInButton />
        </SignIn>
      </UnauthenticatedTemplate>
    </>
  );
};

export default Layout;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    position: "relative",
    minHeight: "100vh",
  },
  drawerHeader: {
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    paddingTop: theme.spacing(1),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: -theme.layout.drawerWidth,
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },
}));
